import React, { ReactNode } from 'react';

interface TradingTerminalLayoutProps {
  header: ReactNode;
  leftPanel: ReactNode;
  chartToolbar: ReactNode;
  chart: ReactNode;
  rightPanel: ReactNode;
  bottomPanel: ReactNode;
}

const TradingTerminalLayout: React.FC<TradingTerminalLayoutProps> = ({
  header,
  leftPanel,
  chartToolbar,
  chart,
  rightPanel,
  bottomPanel
}) => {
  return (
    <div className="flex flex-col h-[calc(100vh-64px)] bg-white overflow-hidden">
      {header}

      <div className="flex flex-1 overflow-hidden">
        <div className="hidden lg:block w-[280px] border-r border-slate-200 overflow-hidden flex-shrink-0">
          {leftPanel}
        </div>

        <div className="flex-1 flex flex-col overflow-hidden min-w-0">
          <div className="flex flex-1 overflow-hidden">
            <div className="hidden lg:flex flex-col w-[48px] border-r border-slate-200 bg-slate-50 flex-shrink-0">
              {chartToolbar}
            </div>

            <div className="flex-1 overflow-hidden min-w-0">
              {chart}
            </div>
          </div>

          <div className="h-[280px] border-t border-slate-200 overflow-hidden flex-shrink-0">
            {bottomPanel}
          </div>
        </div>

        <div className="hidden lg:block w-[320px] border-l border-slate-200 overflow-hidden flex-shrink-0">
          {rightPanel}
        </div>
      </div>
    </div>
  );
};

export default TradingTerminalLayout;
